<template>
    <div class="no-internet">
        <div class="img">
            <NoInternetIcon />
        </div>
        <div class="error-text">
            <h2>{{ $t('something_went_wrong') }}!</h2>
            <p>{{ $t('disconnect_and_retry') }}</p>
        </div>
    </div>
</template>
<script>
import NoInternetIcon from '../components/logo/no-internet.vue'
export default {
    components: {
        NoInternetIcon
    }
}
</script>
<style scoped>
.no-internet {
    background: #55acee;
    width: 100%;
    height: 100vh;
    align-items: center;
    display: flex;
    flex-direction: column;
}
h2{
    font-size: 27px;
    color: #FFFFFF;
    font-family: sans-serif;
}
p{
    font-size: 18px;
    color: #FFFFFF;
    font-family: sans-serif;
}
.error-text{
    padding: 5px;
    text-align: center;
}
</style>